import { createContext, useContext, ReactElement } from "react";

export type SectionItem = {
  element: ReactElement;
  label: string;
  hideDotNav: boolean;
  transparent: boolean;
  id: string;
};

export type FullPageContextType = {
  activeIndex: number;
  scrollToSection: (index: number) => void;
  sectionsCount: number;
  sections: SectionItem[];
  isFullPage: boolean;
};

export const FullPageContext = createContext<FullPageContextType>({
  activeIndex: -1,
  scrollToSection: () => {},
  sectionsCount: 0,
  sections: [],
  isFullPage: false,
});

export function useFullPageContext(): FullPageContextType {
  return useContext(FullPageContext);
}
